import styled from 'styled-components';

import { Button } from '_components/_core';
import { CustomSelectField } from '_components/Financial/BankStatement/Reconcile/components';

export const StyledTable = styled.table`  
    &&& {
    width: 100%;
    font-weight: 400;

    thead tr th {
      height: 32px;
      line-height: 20px;
      padding: 0 9px;
      position: relative;
      background: #FFFFFF;
      vertical-align: middle;
      border-left: 1px solid var(--td-border-color);
      border-bottom: 2px solid var(--td-border-color);
      text-align: left;
      font-size: 0.9em;
      font-weight: 600;
      text-transform: uppercase;
    }
  
    thead tr th:first-child {
      border-left: none;
    }

    tbody tr td {
      line-height: 18px;
      padding: 9px 9px;
      vertical-align: middle;
      border-top: 1px solid var(--td-border-color);
      display: table-cell;
      align-items: center;
      justify-content: center;
      /* font-size: 0.9em; */
    }

    .table-dre {
      tbody tr td {
        background-color: #F9F9F9;
      }
    }
  }
`;

export const StyledUser = styled.span`
  border-bottom: 1px dashed #ccc;
`;

export const RecipientSelect = styled(CustomSelectField)`
  min-width: 15%;
  margin-right: 12px;

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    margin-top: 8px;
  }
`;

export const StyledButton = styled(Button)`
  font-size: 14px;
  font-weight: 500;
  border: none;
  background-color: #f8f9fa;
  color: rgb(7, 20, 55) !important;
  
  &:hover {
    color: #fff !important;
  }
`;

export const FiltersCount = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: red;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
